var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"PartsNav"},[_c('BSCSteppers',{attrs:{"steps":_vm.steps,"type":"success","value":_vm.pagination - 1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }